document.addEventListener('DOMContentLoaded', function () {

  function initHover() {
    const thumbs = document.querySelectorAll('img.bvx-thumb');
    const mainImg = document.getElementById('bvx-main-img');

    if (!thumbs.length || !mainImg) return;

    let originalSrc = mainImg.src;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('mouseenter', function () {
        const bigSrc = this.getAttribute('data-src') || this.src;
        mainImg.src = bigSrc.replace('width=200', 'width=1000');
      });

      thumb.addEventListener('mouseleave', function () {
        mainImg.src = originalSrc;
      });

      thumb.addEventListener('click', function () {
        originalSrc = (this.getAttribute('data-src') || this.src).replace('width=200', 'width=1000');
      });
    });
  }

  initHover();
  setTimeout(initHover, 1500);
});
